import React from "react";
import QueueAnim from 'rc-queue-anim';
import './index.less'
import {Col, Row, Table} from 'antd';
import ScrollOverPack from 'rc-scroll-anim/lib/ScrollOverPack';

export default class OrthographicContent2 extends React.Component {


    render() {
        const columns = [
            {
                title: 'Camera',
                dataIndex: 'name',
                key: 'name',
                align: 'center',
                width: 650
            },
            {
                title: '',
                dataIndex: 'param',
                key: 'param',
                align: 'center',
                width: 650
            },
        ];

        const data = [
            {
                key: '1',
                name: '焦距',
                param: '35/40/50/56mm',
            },
            {
                key: '2',
                name: '有效像素',
                param: '6100万',
            },
            {
                key: '3',
                name: '传感器尺寸',
                param: '全画幅(35.7mm×23.8mm)',
            },
            {
                key: '4',
                name: '曝光间隔',
                param: '≥0.8s',
            },
            {
                key: '5',
                name: '内存',
                param: '1280GB',
            },
            {
                key: '6',
                name: '电源接口',
                param: 'SkyPort',
            },
            {
                key: '7',
                name: '电源开关模式',
                param: '自动 开/关',
            },
            {
                key: '9',
                name: '工作温度',
                param: '-10°C-40°C',
            },
            {
                key: '10',
                name: '工作湿度',
                param: '15%-80%',
            },
            {
                key: '11',
                name: '尺寸',
                param: '127*77*35mm',
            },
            {
                key: '12',
                name: '重量',
                param: '330g',
            }
        ];
        return (
            <ScrollOverPack className='content-wrapper page Orthographic-content2'>
                <Row justify="center">
                    <Col className={"page-box"} span="24">
                        <QueueAnim
                            key="QueueAnim"
                            type={['bottom', 'top']}
                            delay={200}
                            className='text-wrapper Orthographic-text'
                        >
                            <Table columns={columns} dataSource={data} pagination={false}/>
                        </QueueAnim>
                    </Col>
                </Row>


            </ScrollOverPack>
        )

    }
}
